import "./index.scss";
import pf from "../old/pf";
import m from "mithril";
import {Icon, Icons} from "../old/tools/constructui";

export default () => {
	const sidebar = document.querySelectorAll(".left-sidebar")[0];

	const mainItems = Array.from(document.querySelectorAll(".HomePageMarker")).map((a) => {
		return {
			caption: a.innerText,
			url: a.href,
			dashboard: a.getAttribute("dashboard") == "yes",
			isactive: a.getAttribute("selected") == "yes",
		};
	});

	const dashItems = Array.from(document.querySelectorAll(".PrasoraNodeTabsLeft")).map((a) => {
		return {
			caption: a.innerText,
			url: a.href,
			group: a.getAttribute("group") || a.innerText,
			sequence: a.getAttribute("sequence"),
			isactive: a.getAttribute("active") == "yes",
		};
	});

	const groupsNew = dashItems.reduce((p, n) => {
		if (!p[n.group]) {
			p[n.group] = {caption: n.group, links: []};
		}
		// console.log({ p, g: p[n.group], links: p[n.group][links] });
		p[n.group]["links"].push(n);
		p[n.group].isactive = p[n.group].isactive || n.isactive;
		return p;
	}, {});

	const groups = Object.keys(groupsNew).reduce((p, n) => {
		p.push(groupsNew[n]);
		return p;
	}, []);

	//    const groups = Array.from(Map.groupBy(dashItems, d => d.group), ([name, value]) => ({ caption: name, links: value, isactive: value.some(l => l.isactive) }));

	// console.log({ dashItems, mainItems, groups, sidebar })

	const navbar = () => {
		let searchtext = undefined;
		let showsearch = false;
		const searchfilterActive = (g) => {
			if (searchtext)
				return false; //return (pf.regexContains(g.caption, searchtext) || g.links.some(l => pf.regexContains(l.caption, searchtext)));
			else return g.isactive;
		};
		const searchfilterInActive = (g) => {
			if (searchtext)
				return pf.regexContains(g.caption, searchtext) || g.links.some((l) => pf.regexContains(l.caption, searchtext));
			else return !g.isactive;
		};

		return {
			view: () => {
				// console.log({ showsearch });
				return m(".side-bar-section-old", [
					mainItems.length > 0 &&
						m(
							".main-section",
							mainItems
								.filter((a) => !a.dashboard)
								.map((l) => m("a.dash-link.main-link", {class: l.isactive ? "selected" : "", href: l.url}, l.caption))
						),
					m(".dashboard-section", [
						mainItems.filter((a) => a.dashboard).length > 0 && [
							m(
								".title",
								mainItems
									.filter((a) => a.dashboard)
									.map((l) => {
										return m("a.dash-link.main-link", {class: l.isactive ? "selected" : "", href: l.url}, [
											l.caption,
											dashItems.length > 5 &&
												m(
													"a.search-icon",
													{
														onclick: (e) => {
															showsearch = !showsearch;
															e.preventDefault();
														},
													},
													m(Icon, {name: Icons.SEARCH})
												),
										]);
									})
							),
							m(".bottom-spacer"),
						],
						mainItems.filter((a) => a.dashboard).length == 0 &&
							m("details.search-section", [
								m(
									"summary.search-section",
									{
										onclick: () => {
											showsearch = !showsearch;
										},
									},
									m(Icon, {name: Icons.SEARCH})
								),
							]),
						showsearch &&
							m(
								".search",
								m("input", {
									placeholder: "search",
									value: searchtext,
									oninput: (e) => {
										searchtext = e.target.value;
									},
								})
							),
						m(".list", [
							groups.filter(searchfilterActive).map((g) => {
								return g.links.length > 1
									? m(
											"details.group-section",
											{
												open: g.isactive,
											},
											[
												m("summary.group-title", g.caption),
												m(
													".group-items",
													g.links.map((l) =>
														m("a.dash-link", {class: l.isactive ? "selected" : "", href: l.url}, l.caption)
													)
												),
											]
									  )
									: g.links.map((l) => m("a.dash-link", {class: l.isactive ? "selected" : "", href: l.url}, l.caption));
							}),
							groups.filter(searchfilterInActive).map((g) => {
								return g.links.length > 1
									? m(
											"details.group-section",
											{
												open: g.isactive,
											},
											[
												m("summary.group-title", g.caption),
												m(
													".group-items",
													g.links.map((l) =>
														m("a.dash-link", {class: l.isactive ? "selected" : "", href: l.url}, l.caption)
													)
												),
											]
									  )
									: g.links.map((l) => m("a.dash-link", {class: l.isactive ? "selected" : "", href: l.url}, l.caption));
							}),
						]),
					]),
				]);
			},
		};
	};
	if (sidebar && (mainItems.length > 0 || dashItems.length > 0)) m.mount(sidebar, navbar);
};
